"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectronicHealthRecords = exports.BookingStrategies = exports.VisitMethodGroup = void 0;
var VisitMethodGroup;
(function (VisitMethodGroup) {
    VisitMethodGroup["InPerson"] = "in_person";
    VisitMethodGroup["Virtual"] = "virtual";
})(VisitMethodGroup = exports.VisitMethodGroup || (exports.VisitMethodGroup = {}));
var BookingStrategies;
(function (BookingStrategies) {
    BookingStrategies["Availability"] = "Availability";
    BookingStrategies["OpenSchedulingWidget"] = "OpenSchedulingWidget";
    BookingStrategies["Button"] = "Button";
})(BookingStrategies = exports.BookingStrategies || (exports.BookingStrategies = {}));
var ElectronicHealthRecords;
(function (ElectronicHealthRecords) {
    ElectronicHealthRecords["MyChart"] = "mychart";
})(ElectronicHealthRecords = exports.ElectronicHealthRecords || (exports.ElectronicHealthRecords = {}));
//# sourceMappingURL=types.js.map